
import Vue from 'vue';
import PortfolioEditSalesExperienceModalForm from './PortfolioEditSalesExperienceModalForm.vue';
import JobsEditModal from '@/components/partials/jobs/JobsEditModal.vue';
import type { InquiryAndUserInput } from '@/components/partials/public-portfolio/PortfolioJobsInquirySection/PortfolioJobsInquirySectionProfile/types';

export default Vue.extend({
  name: 'PortfolioEditSalesExperienceModal',
  components: {
    JobsEditModal,
    PortfolioEditSalesExperienceModalForm,
  },
  data() {
    return {
      modalName: this.$constants.dynamicModals.PORTFOLIO_SALES_EXPERIENCE_MODAL,
    };
  },
  methods: {
    handleSave(): void {
      (this.$refs.form as Vue & { save: () => void }).save();
    },
    handleUpsert(payload: InquiryAndUserInput): void {
      this.$emit('upsert', { ...payload, modalName: this.modalName });
    },
  },
});
